import { RichText, hasRichText } from '@/components/ui/RichText'

export interface GuidancePageProps {
  /** The assessment's authored instructions (sanitized HTML), or null when none are authored. */
  instructions: string | null
  onBackToOverview: () => void
}

export function GuidancePage({ instructions, onBackToOverview }: GuidancePageProps) {
  return (
    <div className="min-w-0 flex-1 bg-surface">
      <nav aria-label="Breadcrumb" className="border-b border-border px-6 py-5 lg:px-12">
        <button
          type="button"
          onClick={onBackToOverview}
          className="text-base font-semibold text-body underline-offset-2 hover:underline focus-visible:ring-2 focus-visible:ring-focus focus-visible:outline-none"
        >
          Back to overview
        </button>
      </nav>

      <main className="mx-auto max-w-[680px] px-6 py-10">
        <h1 className="text-[32px] leading-tight font-bold tracking-tight text-heading">
          Instructions
        </h1>
        {hasRichText(instructions) ? (
          <RichText html={instructions} className="mt-6 text-[17px] leading-relaxed text-body" />
        ) : (
          <p className="mt-6 text-[17px] text-subtle">
            No guidance has been added for this assessment yet.
          </p>
        )}
      </main>
    </div>
  )
}
